<template>

  <div @update-stats="refreshStats">
      <!-- XOL-34 / XOL-60: Telco users must not see "Add Site". This is the single UI choke point; -->
      <!-- the backend enforces the same rule (XOL-61). Do not remove without updating both sides. -->
      <data-table
        :title="this.title ? this.title : (this.menu === 'all' ? 'All Sites' : titleCase(this.menu, '-') + ' Sites')"
        :title-class="titleClass(menu)"
        title-heading="h2"
        icon="fa fa-broadcast-tower"
        ref="sitetable"
        table-ref="sitetable"
        :url="url"
        :add-action="isTelco() ? null : (isManager() ? action : null)"
        :add-props="addProps"

        :bottom-comp="bComp"
        :bottom-comp-props="addProps"

        :fields="siteFields"
        :sort-field="sortFields"
        :show-refresh="true"
        :params="props"
        search-placeholder="Site IDs, Site Names, Address..."
        detail-component="site-detail-row">

        <template slot="site" slot-scope="props">

          <el-card :body-style="{ backgroundColor: siteBgColor(props.rowData.status), paddingLeft: '1.2em', paddingRight: '1.2em', minHeight: '183px' }" shadow="hover">

           <el-row v-if="props.rowData" :gutter="12">

             <el-col :span="isTelco() ? 18 : 24">
               <h4 :class="titleClass(props.rowData.status)">{{props.rowData.siteName}}
                 <span v-if="props.rowData.telcoSiteId" class="siteid-bubble">
                   <b>{{props.rowData.telcoSiteId}}</b>
                 </span>
                 <span v-if="isCandidate(props.rowData.status)">
                   &nbsp;<org-badge :organisation="props.rowData.candidate" />
                 </span>
<!--
                 <el-button class="pull-right" v-if="showDetail"
                     size="mini"
                     type="primary"
                     icon="fa fa-chevron-right"
                     round
                     @click="showDetails(props.rowData)">
                     View
                 </el-button>
-->

                  <el-col v-if="isTelco() && props.rowData.status === 'Active'" class="pull-right" :span="8" >
                    <!--
                    @TODO fix for map.
                    <el-col v-if="!props.rowData.stats.rts" :span="2" align="center">
                    <request-action button-size="mini" button-type="round" type="RTS" :site-id="props.rowData.id" :row-data="props.rowData" />
                  </el-col>
                  -->
                  <el-col v-if="!props.rowData.stats.rtu || props.rowData.stats.rtu === 0" :span="8" align="center">
                    <request-action button-size="mini" button-type="round" type="RTU" :site-id="props.rowData.id" :row-data="props.rowData" />
                  </el-col>

                  <el-col v-if="!props.rowData.stats.rtb || props.rowData.stats.rtb === 0" :span="8" align="center">
                    <request-action button-size="mini" button-type="round" type="RTB" :site-id="props.rowData.id" :row-data="props.rowData" />
                  </el-col>


                </el-col>
                </h4>


             </el-col>

              <el-col :xs="24" :sm="24" :md="12" :lg="12">

                <!-- eslint-disable-next-line vue/no-v-html -- formatter output, developer-controlled HTML (enum → icon markup) -->
                <span v-if="isTowerCo()" v-html="formatSiteStatus(props.rowData.status)"></span>
                &nbsp;<span class="text-muted">{{props.rowData.siteId}}<b v-if="props.rowData.siteGroup">&nbsp;{{props.rowData.siteGroup}}</b></span>

                <site-stats v-if="isStats(props.rowData)"  :site-id="props.rowData.id"
                 :stats="props.rowData.stats"
                 :show-shadow="showMap ? true : false"
                 />

              </el-col>

              <el-col justify="center" :xs="24" :sm="24" :md="12" :lg="12" align="center">
                  <site-card :site-data="props.rowData" use-leaflet hide-site height="258px" />
              </el-col>
<!--
              <el-col v-else justify="center" :span="24" align="center">
                  <site-card v-if="props.rowData.latitude && props.rowData.longitude" :site-data="props.rowData" use-leaflet hide-site />
                  <div v-else >
                    {{props.rowData.structureName}} {{props.rowData.structureHeight}}
                  </div>
              </el-col>
-->

            </el-row>


              <el-col :span="12" align="left">
                <div v-if="isTowerCo() && (props.rowData.dismantled || props.rowData.handover)">
                  <span v-if="props.rowData.dismantled && props.rowData.status === 'Dismantled'">
                    <span class="text-danger"><small>Dismantled</small>&nbsp;<b>{{formatDate(props.rowData.dismantled)}}</b></span>
                  </span>
                  <span v-else>
                    <span class="text-info"><small>Handover</small>&nbsp;<b>{{formatDate(props.rowData.handover)}}</b></span>
                  </span>
                </div>
                <div v-else>
                  <span class="text-black"><small v-if="props.rowData.onAir">On Air</small>&nbsp;<b>{{formatDate(props.rowData.onAir)}}</b></span>
                </div>
              </el-col>

              <span class="pull-right text-muted" style="z-index: 99;">
                <small>Last Update </small>
                <el-tooltip :content="formatDateTime (props.rowData.updated_at) + (props.rowData.updated_by ? ' by ' + props.rowData.updated_by : '')">
                  <strong>{{formatFriendlyDate (props.rowData.updated_at)}}</strong>
               </el-tooltip>

              </span>

              <el-button v-if="canDeleteSite(props.rowData) && isDesktop" icon="fa fa-trash" @click="deleteSite(props.rowData)" size="small" type="danger" circle></el-button>

          </el-card>
        </template>

      </data-table>

    </div>
<!--
    <transition name="fade" :duration="200">

        <div v-if="!showTable">
          <el-button type="text" icon="fa fa-chevron-left"  @click="showTable = true">&nbsp;Back to Sites</el-button>
          <site-details :row-data="siteData" />
        </div>

    </transition>
-->
  </div>

</template>

<script>

import Vue from 'vue'

import VueEvents from 'vue-events'
Vue.use(VueEvents)

import SiteMixins from '@/mixins/SiteMixins'

import FormattingMixins from '@/mixins/FormattingMixins'

import {MAP_SEARCH_EVENT, MAP_RESET_EVENT, SITETABLE_VIEW_EVENT} from '@/components/Data'

import SiteDetails from '@/components/tables/details/SiteDetails'

import SiteAction from '@/components/actions/SiteAction'
import SiteCard from '@/components/sites/SiteCard'
import SiteStats from '@/components/sites/SiteStats'
import SiteMenu from '@/components/tables/details/SiteMenu'

import RequestAction from '@/components/actions/RequestAction'

Vue.component('site-detail-row', SiteDetails)

export default {
  mixins: [FormattingMixins, SiteMixins],

  components: {
    SiteAction,
    SiteCard,
    SiteDetails,
    SiteStats,
    RequestAction
  },

  props: {

    title: {
      type: String,
      default: null
    },

    view: {
      type: String,
      default: 'all'
    },

    sharer: {
      type: Number,
      default: null
    },

    params: {
      type: Object,
      default: null
    },

    geoSearch: {
      type: Object,
      default: null
    },

    condensed: {
      type: Boolean,
      default: false
    },

    showStatus: {
      type: Boolean,
      default: true
    },

    showMap: {
      type: Boolean,
      default: true
    },

    showDetail: {
      type: Boolean,
      default: false
    }
  },



  methods: {


    selectSite (index) {
      this.menu = index
      this.addProps.status = this.titleCase(index)
    },



    isStats(row) {
      let st = row.stats
      return (st.tickets || st.permits || st.assets || st.actions || st.requests || st.sharers || st.landlords || st.rts || st.rtu || st.rtb || st.backhaul)
    },



    canDeleteSite (row) {

      if (this.isTowerCo() && this.isCandidate(row.status) && this.isManager('finance|management|project')) {
        return true
      }

      return this.isSuper()
    },



    getStructName (row) {
      if (row.structure && row.structure.name) {
        return row.structure.name
      } else {
        if (row.structureType) {
          return row.structureType
        }
      }

      return null
    },



    getStructHeight (row) {
      if (row.structure && row.structure.height) {
        return row.structure.height
      } else {
        if (row.structureHeight) {
          return row.structureHeight
        }
      }

      return null
    },



    mapFilter (search) {
      this.isMapActive = true
      this.showStatusLocal = false
      this.mapSearch = search
    },



    mapClear () {
      this.isMapActive = false
      this.showStatusLocal = true
      this.mapSearch = null
    },



    showDetails (rowData) {

      if (!this.isMapActive) {
        this.siteData = rowData
        this.showTable = !this.showTable
      } else {
        this.findSite(rowData.id, this.fetchSite)
      }
    },

    fetchSite (data) {
      this.siteData = data
      this.showTable = !this.showTable
    },

    deleteSite (rowData) {
      this.deleteItem(this, rowData.id, '/sites', rowData.siteId + ' ' + rowData.siteName + ' AND all it\'s data, including sharers. Are you <i>absolutely</i> sure?', this.onDelete)
    },

    onDelete (response) {
      this.$events.fire('sitetable-refresh-table')
      this.$emit('update-stats')
    }

  },



  computed: {
    url: function () {
      if (this.isMapActive && this.mapSearch) {
        return '/sites/map/' + (this.sharerId ? 'org/' + this.sharerId + '/' : '') +
          this.mapSearch.lat + '/' + this.mapSearch.lng + '/' + this.mapSearch.radius + '/km/10/'
      } else {
        return (this.menu !== 'all' ? '/sites/' + this.menu : '/sites') + (this.sharerId
            ? '/sharer/' + Number(this.sharerId)
          : (this.sharerId ? '/sharer/' + Number(this.sharerId) : ''))
      }
    }
  },





  watch: {

    geoSearch: function (value) {
      this.mapSearch = value
      this.isMapActive = value ? true : false
    },

    sharer: function (value) {
      this.sharerId = value
      this.$refs.sitetable.refresh()
    },

    stats: function (newValue) {
      this.stats = newValue
    }
/*
    '$route.params': {
      handler: function (p) {

        if (p.view) {
          this.menu = p.view.toLowerCase()
        } else {
          this.menu = 'all'
        }

        this.addProps.status = this.menu
      },
      deep: true,
      immediate: true
    }
*/
  },




  data () {

    return {

      menu: this.view.toLowerCase(),
      showStatusLocal: this.showStatus,
      action: SiteAction,

      bComp: SiteMenu,
      addProps: {
        status: this.view === 'all' ? null : this.view,
        view: this.view,
        stats: null,
        show: this.showStatus,
        addSite: true
      },

      showTable: false,

      props: this.params ? this.params : {sharer: this.sharerId},

      sharerId: this.isTelco() ? this.org().id : this.sharer,
      isMapActive: false,
      mapSearch: this.geoSearch,

      siteData: null,

      stats: this.getStats() ? this.getStats() : {},

      sortFields: ['siteName', 'siteId', 'handover', 'zone', 'subdistrict', 'district', 'state', 'region'],

      siteFields: [
        {
          name: '__sequence'
        },
        {
          name: '__slot:site'
        }
      ]
    }

  },


  created () {

    this.addProps.stats = this.stats

    if (this.isTelco()) {
      this.sortFields.push('onAir')
      this.sortFields.push('telcoSiteId')

      if (!this.sharerId) {
        this.sharerId = Number(this.org().id)
      }

    }

    this.$events.listen(MAP_SEARCH_EVENT, this.mapFilter)
    this.$events.listen(MAP_RESET_EVENT, this.mapClear)
    this.$events.listen(SITETABLE_VIEW_EVENT, this.selectSite)

  },



  beforeDestroy () {
    this.$events.remove(MAP_SEARCH_EVENT)
    this.$events.remove(MAP_RESET_EVENT)
    this.$events.remove(SITETABLE_VIEW_EVENT)
  }

}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
</style>
